import { render, staticRenderFns } from "./oil_code.vue?vue&type=template&id=947189fc&"
import script from "./js/oil_code.js?vue&type=script&lang=js&"
export * from "./js/oil_code.js?vue&type=script&lang=js&"
import style0 from "./oil_code.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports